import { readonly, ref } from 'vue';

/**
 * Shared flag: Book inventory Vue Query hooks must not hit the API until
 * `app.init()` has successfully resolved a tenant. Eager prefetch from the
 * app store otherwise fires on invalid hosts (e.g. `app.move.pro`) and
 * reports expected "Tenant not found." 404s to Sentry (MOVEPRO-BOOK-AC).
 */
const tenantReadyState = ref(false);

export const tenantReady = readonly(tenantReadyState);

export function markTenantReady(): void {
    tenantReadyState.value = true;
}

/** Test helper — resets the flag between unit tests. */
export function resetTenantReady(): void {
    tenantReadyState.value = false;
}
